import { HillDetailView } from '@/components/hill-detail-view';
import { sessionQueryOptions } from '@/lib/session-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/hills/:hillId` - single-hill view in **live** mode.
 *
 * The auth guard in `beforeLoad` redirects unauthenticated visitors before the
 * component mounts, matching the list route's pattern. We do NOT preload the
 * hill itself in a loader: the page shell needs to paint immediately so the
 * user has feedback during the fetch - blocking the route transition on a
 * slow hill GET would feel worse.
 *
 * The actual rendering is delegated to `<HillDetailView>` which is shared
 * with `/archive/:hillId`. The `mode` prop here only drives the back link;
 * read-only behaviour comes from the data (`hill.completedAt !== null`).
 */
export const Route = createFileRoute('/hills/$hillId')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions());
    if (!session) {
      throw redirect({ to: '/login' });
    }
  },
  component: HillDetailLivePage,
});

function HillDetailLivePage() {
  const { hillId } = Route.useParams();
  return <HillDetailView hillId={hillId} mode="live" />;
}
